import { createAsyncThunk } from '@reduxjs/toolkit';
import type OfferCodeApi from 'api/digifi/application/OfferCodeApi';
import { ActionType } from 'enums/ActionType';

export const createOfferPrepopulatedDataThunk = (api: OfferCodeApi) => {
  return createAsyncThunk(
    ActionType.FetchPrepopulatedData,
    async (data: { offerCode: string; zipCode: string }) => {
      return await api.getPrepopulatedData(data.offerCode, data.zipCode);
    },
  );
};
